<template>
  <Typography tag="td" color="gray800">
    <div class="empty-wrapper">
      <div class="empty-row" v-if="authStore.me.modify_schedule && !archived">
        <v-btn color="secondary" variant="text" @click="state.show = true" :disabled="loadingBreak">
          <template #prepend>
            <v-icon color="primary-300">mdi-plus-circle</v-icon>
          </template>
          <typography color="primary" weight="600" transform="capitalize">
            Add Meeting</typography
          ></v-btn
        >
      </div>
      <div
        class="empty-row"
        v-if="(authStore.me.set_breaks || authStore.me.modify_schedule) && !archived"
      >
        <v-btn color="secondary" variant="text" @click="$emit('addBreak')" :loading="loadingBreak">
          <template #prepend>
            <v-icon color="secondary300">mdi-coffee</v-icon>
          </template>
          <typography color="secondary" weight="600" transform="capitalize">
            Add break time</typography
          ></v-btn
        >
      </div>
      <div class="empty-row" v-else>
        <!-- Can't modify Schedule -->
      </div>
    </div>
  </Typography>
  <td v-if="showComments"></td>
  <td v-if="noShow"></td>
  <AddMeetingModal
    :conference-day="conferenceDay"
    v-model:show="state.show"
    :timeslot="agenda.timeslot"
    @update:slot="$emit('update:slot', $event)"
  ></AddMeetingModal>
</template>

<script setup lang="ts">
import type { ConferenceDay, GetSchedule } from "@/api_types/teacher";
import { useAuthenticationStore } from "@/stores/authentication";
import { reactive } from "vue";
import AddMeetingModal from "./modal/AddMeetingModal.vue";
import Typography from "../typography.vue";

const authStore = useAuthenticationStore();

defineProps<{
  agenda: GetSchedule;
  loadingBreak: boolean;
  conferenceDay: ConferenceDay;
  noShow: boolean;
  showComments: boolean;
  archived: boolean;
}>();

defineEmits<{
  (e: 'addBreak', ...args: any[]): void;
  (e: 'update:slot', ...args: any[]): void
}>();

const state = reactive({
  show: false
});
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.empty-wrapper {
  display: flex;
  align-items: center;
  min-height: 45px;
  gap: 10px;
  flex-wrap: wrap;
  .empty-row {
    min-height: 45px;
    background-color: $primary-25;
    border: 1px solid $primary-75;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
  }
}
</style>
